
import { Component, Emit, Prop, Vue } from "nuxt-property-decorator";
import PelletsCtaWidget from "~/components/organisms/display/pellets/PelletsCtaWidget.vue";
import type { PelletsState } from "~/types/Pellets";

@Component({
  components: {
    PelletsCtaWidget,
  },
})
export default class PelletsHeroSection extends Vue {
  readonly defaultHeroImage = require("~/assets/images/pellets/pellets-banner.webp");
  readonly defaultHeroImage720 = require("~/assets/images/pellets/pellets-banner-720w.webp");
  readonly defaultHeroImage960 = require("~/assets/images/pellets/pellets-banner-960w.webp");
  readonly defaultHeroImage1280 = require("~/assets/images/pellets/pellets-banner-1280w.webp");

  @Prop({
    default:
      "Aktuelle Pelletspreise vergleichen und günstig Holzpellets kaufen",
  })
  title!: string;

  @Prop({ default: null }) priceData!: PelletsState | null;
  @Prop({ default: null }) heroImage!: string | null;
  @Prop({ default: "Holzpellets" }) heroImageAlt!: string;

  @Emit("cta-visibility-change")
  onCtaVisibilityChange(visible: boolean): boolean {
    return visible;
  }

  get resolvedHeroImage(): string {
    return this.heroImage || this.defaultHeroImage;
  }

  get resolvedHeroSrcset(): string | null {
    if (this.heroImage) return null;
    return `${this.defaultHeroImage720} 720w, ${this.defaultHeroImage960} 960w, ${this.defaultHeroImage1280} 1280w, ${this.defaultHeroImage} 1920w`;
  }
}
